import { getObsTokenReq } from '@/api/global';
import OSS from 'ali-oss';

/**
 * 公开桶 → CDN 域名映射表
 * 新增公开桶时只需在此加一行（桶名: 域名），无需改动任何调用方
 */
const PUBLIC_BUCKET_CDN_MAP = {
    'function-attachment-upload': 'https://grt-cdn.grtcloud.net'
    // 'another-public-bucket': 'https://xxx-cdn.grtcloud.net',
},

/**
 * 从公开桶绑定的 CDN 直读 JSON 配置（公开桶无需 STS 凭证）
 * @param {string} cdnBase CDN 域名，如 'https://grt-cdn.grtcloud.net'
 * @param {string} objectKey 桶内对象路径
 * @returns {Promise<Object|null>} 解析后的 JSON 对象，失败返回 null
 */
 fetchCdnJson = async function (cdnBase, objectKey) {
    if (!objectKey) return null;
    try {
        const res = await fetch(`${cdnBase}/${objectKey}`);
        if (!res.ok) {
            console.error(`[obsDownloadFile] CDN ${res.status}: ${objectKey}`);
            return null;
        }
        return await res.json();
    } catch (e) {
        console.error('[obsDownloadFile] CDN 请求失败:', objectKey, e);
        return null;
    }
},

 obsDownloadFile = async function (bucketName, objectKey) {
        // 公开桶：直连 CDN 读取，不请求 STS 凭证、不使用 ali-oss
        const cdnBase = PUBLIC_BUCKET_CDN_MAP[bucketName];
        if (cdnBase) return fetchCdnJson(cdnBase, objectKey);
        let finalRes = null;
        const { data, code } = await getObsTokenReq();
        if (code === '00000') {
            let obj = {
                // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                region: 'oss-cn-beijing',
                authorizationV4: true,
                // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                accessKeyId: data.access_key_id,
                accessKeySecret: data.access_key_secret,
                // 从STS服务获取的安全令牌（SecurityToken）。
                stsToken: data.security_token,
                // 填写Bucket名称。
                bucket: bucketName
            };
            const client = new OSS(obj),
             res = await client.get(objectKey);
            if (res && res.content) {
                const decoder = new TextDecoder('utf-8'),
                 jsonString = decoder.decode(res.content);
                finalRes = JSON.parse(jsonString);
            }

            return finalRes;
        }
    },
    obsDownloadFileSaveByType = async function (bucketName, objectKey) {
        const { data, code } = await getObsTokenReq();
        if (code === '00000') {
            const client = new OSS({
                // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                region: 'oss-cn-beijing',
                authorizationV4: true,
                // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                accessKeyId: data.access_key_id,
                accessKeySecret: data.access_key_secret,
                // 从STS服务获取的安全令牌（SecurityToken）。
                stsToken: data.security_token,
                // 填写Bucket名称。
                bucket: bucketName
            }),
             url = client.signatureUrl(objectKey, {});
            return url;
        }
    };

export { obsDownloadFile, obsDownloadFileSaveByType };
